<template>
  <lazy-component
    class="article-block article-block--list-item"
  >
    <div
      class="article-block__image"
    >
      <a :href="video.url">
        <img
          :src="video.coverImage"
          :alt="video.title"
        >
      </a>
    </div>
    <div class="article-block__content">
      <a
        class="article-block__title"
        :href="video.url"
        style="-webkit-box-orient: vertical;"
      >
        <h2>
          {{ video.title }}
        </h2>

        <label class="article-block__author">
          <template v-if="video.publishedAt">
            on {{ formattedPublishedAt }}
          </template>
        </label>
      </a>
      <div class="article-block__footer">
        <a
          v-if="action"
          class="article-block__action"
          :href="video.url"
        >
          {{ action }}
        </a>
        <div
          v-if="video.formattedViews"
          class="article-block__spins"
        >
          <label>VIEWS</label>
          <i class="bandwagon-logo bandwagon-logo--arc" />
          <label class="article-block__spins-number">
            {{ video.formattedViews }}
          </label>
        </div>
      </div>
    </div>
  </lazy-component>
</template>

<script>
export default {
  name: 'ArticleVideoBlockSearchComponent',
  props: {
    action: {
      type: String,
      default: undefined,
    },
    video: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    formattedPublishedAt() {
      if (this.video.publishedAt === undefined) return '';

      return (new Date(this.video.publishedAt)).toLocaleString('en-SG', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
  },
};
</script>
